<template>
  <div>
    <panel-view title="Comments">

    </panel-view>
  </div>
</template>

<script>
export default {
  
}
</script>

<style scoped>

</style>
